// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lXyq","importantInfo":"styles_importantInfo__1t9ZJ"};